import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { UserService } from "cw-backend";
import { AuthService } from "cw-services";
import { Subject } from "rxjs";
import { MetaService } from "../../../../../shared/cw-backend/providers/system/meta/meta.service";

@Component({
    selector: "app-modal-defaulters",
    templateUrl: "./modal-defaulters.component.html",
    styleUrls: ["./modal-defaulters.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class ModalDefaultersComponent implements OnInit {
    public status: string;

    action: string;

    token: string;

    disableButton: boolean = true;

    message: string;

    private _unsubscribeAll: Subject<any>;
    scheduleIdle: number = 10;

    constructor(
        private _formBuilder: FormBuilder,
        public _matDialogRef: MatDialogRef<ModalDefaultersComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private userservice: UserService,
        private authService: AuthService,
        private metaService: MetaService
    ) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        if (this.status == "BLOCKED") {
            this.getMessageBlocked();
        } else {
            this.getMessage();
        }
    }

    openWhatsapp() {
        let urlToWhats = "https://wa.me/7196115672?text=Olá,%20";

        window.open(urlToWhats, "_blank");
    }

    handleEvent(event) {
        if (event.action == "done") {
            this.action = "done";
            this.disableButton = false;
        }
    }

    confirm() {
        if (this.status == "BLOCKED") {
            this.logout();
        } else {
            // Fecha o diálogo e retorna true para o chamador
            this._matDialogRef.close(true);
        }
    }

    logout() {
        this.userservice.logout().then(() => {
            this.authService.logout();
            localStorage.clear();
            sessionStorage.clear();
            //Adicionado o trecho abaixo para força um recaregamento de pagina assim eliminando o cache
            window.location.href = "/?v=" + Date.now();
            // comentado o trecho abaixo para evitaar manter o cache
            //   this.router.navigate(["auth/login"]);
        });
    }

    getMessage() {
        if (this.token) {
            this.metaService.getMessageToken(this.token).then((res) => {
                this.message = res.data;
                this.showMessage();
            });
        } else {
            this.metaService.getMessage().then((res) => {
                this.message = res.body.data;
                this.showMessage();
            });
        }
    }

    getMessageBlocked() {
        if (this.token) {
            this.metaService.getMessageBlockedToken(this.token).then((res) => {
                this.message = res.data;
                this.showMessage();
            });
        } else {
            this.metaService.getMessageBlocked().then((res) => {
                this.message = res.body.data;
                this.showMessage();
            });
        }
    }

    showMessage() {
        let element = document.getElementById("info");
        element.insertAdjacentHTML("beforeend", this.message);
    }
}
